var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.173,
    height: 79.699,
    viewBox: "0 0 66.173 79.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.75 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.945,10.722A2.847,2.847,0,1,1,14.1,7.875,2.847,2.847,0,0,1,16.945,10.722Z",
    transform: "translate(6.89 6.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.945,19.722A2.847,2.847,0,1,1,14.1,16.875,2.847,2.847,0,0,1,16.945,19.722Z",
    transform: "translate(6.89 20.669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.945,28.722A2.847,2.847,0,1,1,14.1,25.875,2.847,2.847,0,0,1,16.945,28.722Z",
    transform: "translate(6.89 34.448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,3.375H12.445A5.7,5.7,0,0,0,6.75,9.07V71.712a5.7,5.7,0,0,0,5.695,5.695H35.224V71.712H12.445V54.628H63.7V9.07A5.7,5.7,0,0,0,58,3.375Zm0,45.558H12.445V31.849H58Zm0-22.779H12.445V9.07H58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,45.455,39.442,37.4,47.5,29.337l-4.014-4.014-8.059,8.031-8.059-8.028L23.355,29.34,31.414,37.4l-8.059,8.059,4.014,4.014,8.059-8.059,8.059,8.059L47.5,45.457Z",
    transform: "translate(25.422 33.603)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataError);
export default __webpack_public_path__ + "static/media/data-error.5b280a0e0165fd891dfe52b2f6522b54.svg";
export { ForwardRef as ReactComponent };